<template>
  <img :src="imageSource" :alt="imageAlt" :class="classes">
</template>

<script>
export default {
  data() {
    return {
      cornerClass: {
        rounded: 'rounded-lg',
        squared: 'rounded-none',
      },
    };
  },
  props: {
    imageSource: {
      type: String,
    },
    imageAlt: {
      type: String,
    },
    corner: {
      type: String,
      default: 'squared',
    },
    width: {
      type: String,
      default: 'w-full',
    },
  },
  computed: {
    classes() {
      return `${this.cornerClass[this.corner]} ${this.width}`;
    },
  },
};
</script>
